// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

function checkRequiredProps (props) {
  if (!props.appIdentifier || props.appIdentifier === '')
    throw new Error(
        "Please provide an appIdentifier for " +
        "your third-app that use Olympus-Frontend, " +
        "see configs"
    )
}

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    appInfo: {
      appTitle: 'Project Title',
      appIdentifier: 'App Identifier',
      appLogoImage: 'logo-success.png'
    },
    loginInfo: undefined,
  },
  reducers: {
    setAppConfiguration: (state, action) => {
      checkRequiredProps(action.payload.config)
      state.appInfo = action.payload.config;
    }
  }
})

export const { setAppConfiguration } = appSlice.actions

export default appSlice.reducer
